import { useCallback, useEffect, useState } from 'react';
import { getCandidateScreeningProgressSummary } from '../../../service/VolunteerApplicationService';
import { useAuth } from '../../../hooks/useAuth';
import { useBatchId } from '../../../hooks/useBatchId';
import { useToastMessage } from '../../../hooks/useToastMessage';
import {
	CandidateScreeningProgressSummaryFilter,
	CandidateScreeningProgressSummaryResponse,
} from '../../../shared/VolunteerApplicationServiceTypes';

export const useScreeningDashboard = () => {
	const { srcmId } = useAuth();
	const { batchId } = useBatchId();
	const { showToastMessage } = useToastMessage();
	const [adminDashboardResponse, setAdminDashboardResponse] =
		useState<CandidateScreeningProgressSummaryResponse>();
	const [dashboardFilter, setDashboardFilter] =
		useState<CandidateScreeningProgressSummaryFilter>({});

	const onDashboardFilterChange = useCallback(
		(filterParam: CandidateScreeningProgressSummaryFilter) => {
			setDashboardFilter(filterParam);
		},
		[]
	);

	const getCandidateScreeningProgressSummaryData = useCallback(
		async (filter: CandidateScreeningProgressSummaryFilter) => {
			if (srcmId && batchId) {
				try {
					const screeningDashboardResponse =
						await getCandidateScreeningProgressSummary({
							functionarySrcmId: srcmId,
							batchId,
							filter,
						});
					if (screeningDashboardResponse) {
						setAdminDashboardResponse(screeningDashboardResponse);
					}
				} catch (err) {
					showToastMessage(
						'error',
						err instanceof Error ? err.message : 'Unknown error occurred'
					);
				}
			}
		},
		[srcmId, batchId, showToastMessage]
	);

	useEffect(() => {
		void getCandidateScreeningProgressSummaryData(dashboardFilter);
	}, [dashboardFilter, getCandidateScreeningProgressSummaryData]);

	return {
		adminDashboardResponse,
		dashboardFilter,
		onDashboardFilterChange,
	};
};
